import { uniqueKey } from 'global/common/keys'
import { gEnums } from 'global/enums/globalEnums'
import ListAdd from 'global/lists/ListAdd'
import SemFileViewer from '../sem/SemFileViewer'
import AppUserDataPermissions from './elements/AppUserDataPermissions'
import { ColorPicker } from './elements/ColorPicker'
import MenuItemsSelect from './elements/MenuItemsSelect'
import NumberPicker from './elements/NumberPicker'
import ThemedColors from './elements/ThemedColors'
import ItemMap from './groupedElements/ItemMap'
import { getFormOptions } from './props/formOptions'

export const FormItemsAlt = ({ formItemType, _key, fip, prop, optionsList, localData, itemProp, item, handleChange, formKey }) => {

  console.log('formItemType', formItemType)

  switch (formItemType) {
    case gEnums.formItemTypes.appUserDataModificationList:
      return <AppUserDataPermissions />

    case gEnums.formItemTypes.fileSelect:
      return <SemFileViewer fileMode={gEnums.fileModes.viewWithSelect} noMid={true} />

    case gEnums.formItemTypes.gridRowSelect:
    case gEnums.formItemTypes.gridRowSelectFull:
    case gEnums.formItemTypes.menuItemSelect:
    case gEnums.formItemTypes.menuItemSelectFull:
    case gEnums.formItemTypes.menuItemSelectFullCount:
      const optionsProps = { itemProp, optionsList, data_init: {}, fip }
      // let optionList = itemProp?.data?.trueList || getFormOptions(optionsProps)
      // const asdf = getFormOptions(optionsProps)
      // console.log('asdf', asdf)
      // console.log('optionsList', optionsList)
      return <MenuItemsSelect menuList={optionsList?.activeViList || optionsList} fip={fip} />

    case gEnums.formItemTypes.backgroundColorSelectSingle:
    case gEnums.formItemTypes.colorSelect:
    case gEnums.formItemTypes.colorSelectSingle:
      return <ThemedColors key={uniqueKey('fi', 'tc', _key)} handleChange={handleChange} formKey={formKey} fip={fip} prop={prop} itemProp={itemProp} aaa={_key} cc={localData} item={item} />

    case gEnums.formItemTypes.colorPicker:
      return <ColorPicker key={uniqueKey('fi', _key)} fip={fip} prop={prop} themeColors={localData} />;

    case gEnums.formItemTypes.slider:
      return <NumberPicker fip={fip} itemProp={{}} />

    case gEnums.formItemTypes.listAdd:
    case gEnums.formItemTypes.listView:
      return <ListAdd fip={fip} inverted={true} />

    case gEnums.formItemTypes.itemMap:
    case gEnums.formItemTypes.itemArrayMulti:
      return <ItemMap fip={fip} formItemType={formItemType} themeColors={localData} labelProps={itemProp?.data ? itemProp?.data?.labelProps : null} />

  }
  return (
    <div>FormItemsAlt</div>
  )
}
